<template>
  <div class="pageWhild" style="height: 100%;">
    <div style="margin: 20px 0px;">
      <div v-for="(item,index) in Arr" :key="index">
        <!-- 证件照 -->
          <div class="inline-block" style="align-items: flex-start;">
            <label class="w100 textRight"><span class="red">*</span>{{getzhengjianText(item.type)}}：</label>
            <div class="Fiw500">
              <el-upload :headers="utils.headup()" class="elupload" style="margin-right: 20px;"
                         action="/file/upload" ref="upload" :on-error="handleError" :accept="item.type=='TAX_CERTIFICATE'?'.jpeg,.jpg,.png,.pdf':'.jpeg,.jpg,.png'"
                         multiple:limit="1" :http-request="(file)=>{return uploadURL(file,'BUSINESS_LICENSE',index,item)}">
                <!-- :on-success="(res) => { return handleAvatarSuccess(res,'file',index)}" -->
                <div class="AddUpDiv cursorcss">
                  <i class="iconfont icon-tianjia3" v-show="!item.file"></i>
                  <p v-show="!item.file">{{$t('operateContractSign.Pleaseuploadthefile')}}</p>
                  <p class="AddUpDiv-pRight" @click.stop="Viewexample(item.type)">
                    {{$t('enterprise.Viewexample')}}
                  </p>
				  <p class="AddUpDiv-pBottom" v-if="item.type=='TAX_CERTIFICATE'">{{$t('enterprise.SupportsJPGPNGandJPGEPDFformatsupto20MB')}}
				  </p>
				  <p class="AddUpDiv-pBottom" v-else>{{$t('enterprise.SupportsJPGPNGandJPGEformatsupto10MB')}}
				  </p>
                  <div v-show="item.file" class="imgFileCss">
                    <img style="width: 100%;" :src="dataFile[index].personalIdFrontFile">
                  </div>
                </div>
                <div>
                  <el-progress :percentage="dataFile[index].BUSINESS_LICENSEvideoUploadPercent"></el-progress>
                </div>
              </el-upload>
            </div>
          </div>

        <!-- 证件有效期 -->
        <div class="module-bg">
          <div class="inline-block">
            <label class="w100 textRight"><span
                class="red">*</span>{{$t('LegalPerson.Certificatevalidityperiod')}}：</label>
            <div>
              <el-date-picker
                  style="width: 180px"
                  v-model="item.startDate"
                  type="date"
                  :picker-options='pickerStartOptions(item.endDate)'
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('expire.Validityperiodofdocument1')">
              </el-date-picker>
              -
              <el-date-picker
                  style="width: 180px"
                  v-model="item.endDate"
                  :disabled="item.longDate=='1'"
                  type="date"
                  :picker-options='pickerEndOptions()'
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('expire.Validityperiodofdocument2')">
              </el-date-picker>
              <el-checkbox style="margin-left: 5px;" :checked="item.longDate=='1'? true:false" :true-label="1"
                           :false-label="0" v-model="item.longDate">{{$t('LegalPerson.overalongperiodoftime')}}</el-checkbox>
            </div>
          </div>
        </div>
        <div style="height: 1px;background-color: #F1F3F5;margin: 20px 0;" v-show="index!=Arr.length-1"></div>
      </div>
    </div>
    <el-dialog :title="$t('enterprise.Example')" :visible.sync="ViewexampleShow" width="400px"  append-to-body>
      <div style="margin-bottom: 10px;">
        <div style="text-align: center;height: 300px;overflow-y: scroll;" class="example">
          <img style="width: 100%;" v-for="(item,index) in ViewexampleImg" :key="index" :src="item">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import {eventBus} from "@/common/eventBus";
export default {
  props:['Otherdos','ChangeData'],
  data() {
    return {
      sharholder:[],
      sltimes: [], //测试
      typeMap:[],
      Arr: [{
        "number": "",
        "file": "",
        "startDate": '',
        'endDate':'',
        'longDate':''
      }],
      ViewexampleShow: false,
      ViewexampleImg: [],
      MerchantInfo: {},
      dataFile: [{
        'personalIdFrontFile': '',
        'BUSINESS_LICENSEvideoUploadPercent': 0,
      }],
      pickerStartOptions(endTime) {
        return {
          disabledDate(time) {
            if (endTime) {
              // 拼接 00:00:00 是为了统一日期从0点开始
              return time.getTime() > new Date(endTime).getTime();
            }
          }
        }
      },
      pickerEndOptions() {
        return {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7; // 禁用今天以前的日期
          }
        }
      }
    }
  },
  async created() {
    eventBus.$on('custom-otherdoc', () => {
      // 处理接收到的事件
      this.Lstep()
    });

    // this.MerchantInfo = await this.$common.merchantGetMerchantInfo()

    if (this.Otherdos) {
      this.sharholder = this.Otherdos.filter(value => value.type === 'BUSINESS_LICENSE' || value.type === 'REGISTER_CI' || value.type === 'REGISTER' || value.type === 'TAX_CERTIFICATE');
      this.typeMap = {
        BUSINESS_LICENSE: this.$t('enterprise.Enterprisebusinesslicense'),
        REGISTER_CI: this.$t('enterprise.EnterpriseRegistrationCl'),
        REGISTER: this.$t('enterprise.companyregistrationcertificate'),
        TAX_CERTIFICATE: this.$t('enterprise.Taxcertificateorbusinessregistration')
      };
      // this.Arr = this.sharholder
      // this.Arr.map((s)=>(s.file='',s.fileBack='',s.longDate='',s.passportFile='',s.startDate=''))
      let obj={
        longDate:'',
        file:'',
        startDate:'',
        endDate:''
      }
      let Arrs=[]
      for(let i of this.sharholder){
        i={...i,...obj}
        Arrs.push(i)
      }
      this.Arr = Arrs.filter(item => item.type !== '');
      for (let i in this.Arr) {
        let obj = {
          'personalIdFrontFile': '',
          'BUSINESS_LICENSEvideoUploadPercent': 0,
        }
        if (this.utils.IsitEmpty(this.Arr[i].file)) {
          obj.personalIdFrontFile = await this.$common.clientOSSDownload(this.Arr[i].file)
          obj.BUSINESS_LICENSEvideoUploadPercent = 100
        }
        if (this.utils.IsitEmpty(this.Arr[i].fileBack)) {
          obj.personalIdBackFile = await this.$common.clientOSSDownload(this.Arr[i].fileBack)
          obj.personalIdBackvideoUploadPercent = 100
        }
        if (this.utils.IsitEmpty(this.Arr[i].passportFile)) {
          obj.passportFileFile = await this.$common.clientOSSDownload(this.Arr[i].passportFile)
          obj.passportFilevideoUploadPercent = 100
        }
        if(this.utils.IsitEmpty(this.Arr[i].longDate)){
          this.Arr[i].longDate=parseInt(this.Arr[i].longDate)
        }
        if (this.utils.IsitEmpty(this.Arr[i].shareholderAddressFile)) {
          let fileFormat = this.Arr[i].shareholderAddressFile.substring(this.Arr[i].shareholderAddressFile.lastIndexOf(".")).toLowerCase();
          if (!fileFormat.match(/.jpeg|.jpg|.png/)) {
            obj.shareholderAddressFileFile = require('../../assets/Internet/tsfile.jpg')
          }else{
            obj.shareholderAddressFileFile = await this.$common.clientOSSDownload(this.Arr[i].shareholderAddressFile)
          }
          obj.shareholderAddressFilevideoUploadPercent = 100
        }
        this.dataFile.push(obj)
      }
    }

  },
  // 通过计算属性改变字体
  computed: {
    getzhengjianText() {
      return function(index) {
        return this.typeMap[index]
      };
    }
  },
  methods: {
    // 下一步
    async Lstep() {
      this.$emit('custom-other', this.Arr);
    },
    // 查看实例
    Viewexample(index) {
      this.ViewexampleImg = []
      if (index == 'TAX_CERTIFICATE') {
        this.ViewexampleImg.push(require('@/assets/Inter/taxcertificatehongkong.png'))
        this.ViewexampleImg.push(require('@/assets/Inter/taxcertificatehongkong.jpg'))
      } else {
        this.ViewexampleImg.push(require('@/assets/Inter/companyregistrationcertificateZh.jpg'))
        this.ViewexampleImg.push(require('@/assets/Inter/companyregistrationcertificatehongkong.jpg'))
      }

      this.ViewexampleShow = true
    },
    // 上传文件失败
    handleError(res, file) {
      this.$refs.upload.clearFiles()
      let resm = JSON.parse(res.message)
      this.$message.warning(resm.message)
      if (resm.code == '401') {
        this.$router.push('/login')
      }
      this.openLoading().close();
    },
    beforeUploadVideo(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t("login.Uploadfileistoolarge"))
        return false   //必须返回false
      }
      this.openLoading();
    },
    // 直传oss
    async uploadURL(file, type, index,item) {
		this.openLoading();
      let filePath = file.file.name
      let fileFormat = filePath.substring(filePath.lastIndexOf(".")).toLowerCase();
      if (file.file.size / 1024 / 1024 > 20) {
        this.$message.warning(this.$t('enterprise.Pleaseuploadafilenotexceeding20minsize') )
        await this.openLoading().close();
        return false
      }
	  if(item.type=='TAX_CERTIFICATE'){
		  if (!fileFormat.match(/.jpeg|.jpg|.png|.pdf/)) {
		    this.$message.warning(this.$t('radeReceColl.Incorrectfileformat') )
		    await this.openLoading().close();
		    return false
		  }
	  }else{
		  if (!fileFormat.match(/.jpeg|.jpg|.png/)) {
		    this.$message.warning(this.$t('radeReceColl.Incorrectfileformat') )
		    await this.openLoading().close();
		    return false
		  }
	  }

      if (type == 'BUSINESS_LICENSE') {
        this.dataFile[index].BUSINESS_LICENSEvideoUploadPercent=0
      }

      let ObjOss=await this.$common.clientOSS(file,this.dataFile[index],'initiateDeceRouter',type)
      let OrcDataObj=''

      if (type == 'BUSINESS_LICENSE') {
        this.Arr[index].file = ObjOss.oldFile
		if (!fileFormat.match(/.jpeg|.jpg|.png/)) {
			this.dataFile[index].personalIdFrontFile = require('../../assets/Internet/tsfile.jpg')
		} else {
			this.dataFile[index].personalIdFrontFile = await this.$common.clientOSSDownload(ObjOss.oldFile)
		}

        OrcDataObj=await this.$common.OrcRecognize('','BUSINESS_LICENSE',ObjOss.oldFile)
        if(this.utils.IsitEmpty(OrcDataObj)&&this.utils.IsitEmpty(OrcDataObj.idInfo)){
          if(OrcDataObj.idInfo.signDate){
            this.Arr[index].startDate= moment(OrcDataObj.idInfo.signDate).format("YYYY-MM-DD")
          }else{
            this.Arr[index].startDate=''
          }
          if(!OrcDataObj.idInfo.expireDate.indexOf('长期')){
            this.Arr[index].longDate=1
          }else{
            this.Arr[index].endDate= moment(OrcDataObj.idInfo.expireDate).format("YYYY-MM-DD")
          }
        }else{

          this.Arr[index].startDate=''
          this.Arr[index].endDate=''
          this.Arr[index].longDate=''
        }
      }

      await this.openLoading().close();
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .inline-block {
  align-items: baseline;
}
/deep/ .elupload{
  width: 100%;
}
.inputZj {
  width: 435px;
}
.AddUpDiv {
  width: 100%;
  // background: #FAFCFF;
  border: 1px solid #D7DDE7;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #B7C0CF;
  text-align: center;
  padding-bottom: 60px;
  position: relative;

  &-pRight {
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1B62F0;
    padding: 6px 14px;
  }

  &-pBottom {
    position: absolute;
    bottom: 0;
    height: 35px;
    background: #FFF4F2;
    border-radius: 3px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #EF6B58;
    line-height: 35px;
    width: 100%;
  }
  &>i {
    color: #D7DDE7;
    font-size: 42px;
    margin-top: 40px;
    margin-bottom: 20px;
    display: inline-block;
  }
}

.H3p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FC373C;
  margin-left: 20px;
}

/deep/ .module-bg {
  margin: 0 10px;
}

.AddCss {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #1B62F0;
}
</style>
